
<!-- src/src/components/admin/HotSearchDialog.vue -->
<template>
  <el-dialog
    title="热门搜索与命中分析"
    :visible.sync="dialogVisible"
    width="1500px"
    append-to-body
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <!-- 筛选条件栏 -->
    <div class="filter-bar">
      <el-date-picker
        v-model="dateRange"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="small"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptions"
        style="width: 280px;"
        @change="onDateChange"
      />

      <el-select
        v-model="workspaceSlug"
        placeholder="命中文档所在知识库"
        size="small"
        clearable
        filterable
        style="width: 180px; margin-left: 12px;"
        @change="onSearch"
      >
        <el-option
          v-for="ws in workspaceList"
          :key="ws.slug"
          :label="ws.name"
          :value="ws.slug"
        />
      </el-select>

      <el-select
        v-model="isHit"
        placeholder="命中状态"
        size="small"
        clearable
        style="width: 120px; margin-left: 12px;"
        @change="onSearch"
      >
        <el-option label="全部" :value="null" />
        <el-option label="命中" :value="1" />
        <el-option label="未命中" :value="0" />
      </el-select>

      <el-select
        v-model="minSearchCount"
        placeholder="最低搜索次数"
        size="small"
        style="width: 140px; margin-left: 12px;"
        @change="onSearch"
      >
        <el-option label="≥1次" :value="1" />
        <el-option label="≥2次" :value="2" />
        <el-option label="≥5次" :value="5" />
        <el-option label="≥10次" :value="10" />
        <el-option label="≥20次" :value="20" />
      </el-select>

      <el-input
        v-model="keyword"
        placeholder="搜索关键词"
        size="small"
        clearable
        style="width: 180px; margin-left: 12px;"
        @keyup.enter.native="onSearch"
        @clear="onSearch"
      >
        <i slot="prefix" class="el-icon-search" />
      </el-input>

      <el-button type="primary" size="small" @click="onSearch" style="margin-left: 12px;">
         <svg t="1785663606858" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6435" width="16" height="16"><path d="M449.1 732.9c-77.8 0-151-30.3-206-85.3s-85.3-128.2-85.3-206 30.3-151 85.3-206 128.2-85.3 206-85.3c77.8 0 151 30.3 206 85.3s85.3 128.2 85.3 206-30.3 151-85.3 206-128.2 85.3-206 85.3z m0-532.7c-133.1 0-241.4 108.3-241.4 241.4S316 682.9 449.1 682.9c133.1 0 241.4-108.3 241.4-241.4S582.2 200.2 449.1 200.2z" p-id="6436" fill="#ffffff"></path><path d="M609.135 636.88l35.355-35.355L875.853 832.89l-35.355 35.355z" p-id="6437" fill="#ffffff"></path></svg>
         查询
      </el-button>

      <el-button size="small" @click="handleExport">
        <svg t="1785663734431" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7542" width="16" height="16"><path d="M946.4 305c-34.1 0-61.7 28-61.7 62.6v375.8c0 34.5-27.6 62.6-61.7 62.6H206.2c-34 0-61.7-28.1-61.7-62.6V367.6c0-34.6-27.6-62.6-61.7-62.6s-61.7 28-61.7 62.6v375.8c0 103.6 83 187.9 185.1 187.9h616.9c102 0 185.1-84.3 185.1-187.9V367.6c-0.1-34.6-27.7-62.6-61.8-62.6z" fill="#1296db" p-id="7543"></path><path d="M298.7 305h61.7c17 0 30.8 14.1 30.8 31.3v125.3c0 17.3 13.9 31.3 30.8 31.3h185c17 0 30.9-14.1 30.9-31.3V336.3c0-17.2 13.9-31.3 30.8-31.3h61.7c17 0 21-10 9-22.1l-203-206.3c-12-12.2-31.6-12.2-43.6 0L289.7 282.9c-12 12.1-7.9 22.1 9 22.1zM422.1 555.6c-17.1 0-30.8 13.9-30.8 31.3 0 17.2 13.8 31.3 30.8 31.3h185.1c17.1 0 30.8-14.1 30.8-31.3 0-17.4-13.8-31.3-30.8-31.3H422.1z" fill="#1296db" p-id="7544"></path></svg>
         导出
      </el-button>

      <span style="margin-left: 16px; color: #909399; font-size: 13px;">
        共 {{ total }} 个搜索词
      </span>
    </div>

    <!-- 统计摘要 -->
    <div class="summary-bar">
      <el-row :gutter="20">
        <el-col :span="4">
          <div class="summary-item">
            <span class="summary-label">总搜索次数</span>
            <span class="summary-value">{{ totalSearchCount }}</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="summary-item">
            <span class="summary-label">总命中次数</span>
            <span class="summary-value" style="color: #67c23a;">{{ totalHitCount }}</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="summary-item">
            <span class="summary-label">总未命中次数</span>
            <span class="summary-value" style="color: #f56c6c;">{{ totalNoHitCount }}</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="summary-item">
            <span class="summary-label">整体命中率</span>
            <span class="summary-value" style="color: #409EFF;">{{ overallHitRate }}</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="summary-item">
            <span class="summary-label">平均置信度</span>
            <span class="summary-value" style="color: #e6a23c;">{{ overallAvgConfidence }}</span>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 表格 -->
    <el-table
      ref="hotSearchTable"
      :data="tableData"
      v-loading="loading"
      border
      stripe
      style="width: 100%; margin-top: 12px;"
      max-height="480"
    >
      <el-table-column prop="rank" label="排名" width="60" align="center">
        <template slot-scope="{ row }">
          <span :style="getRankStyle(row.rank)">
            {{ row.rank }}
          </span>
        </template>
      </el-table-column>

      <el-table-column prop="queryText" label="搜索词" min-width="150" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <span class="query-text">{{ row.queryText }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="searchCount" label="搜索次数" width="100" align="center" sortable>
        <template slot-scope="{ row }">
          <el-tag type="info" size="mini">{{ row.searchCount }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column prop="hitCount" label="命中次数" width="100" align="center">
        <template slot-scope="{ row }">
          <span style="color: #67c23a; font-weight: 600;">{{ row.hitCount }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="noHitCount" label="未命中次数" width="100" align="center">
        <template slot-scope="{ row }">
          <span style="color: #f56c6c; font-weight: 600;">{{ row.noHitCount }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="hitRate" label="命中率" width="100" align="center">
        <template slot-scope="{ row }">
          <el-tag :type="getHitRateType(row.hitRate)" size="mini">
            {{ row.hitRate }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column prop="avgConfidence" label="平均置信度" width="110" align="center">
        <template slot-scope="{ row }">
          <span v-if="row.avgConfidence > 0">
            <el-progress 
              :percentage="Math.round(row.avgConfidence * 100)" 
              :color="getConfidenceColor(row.avgConfidence)"
              :stroke-width="6"
              style="width: 80px; display: inline-block;"
            />
          </span>
          <span v-else style="color: #c0c4cc;">-</span>
        </template>
      </el-table-column>

      <el-table-column prop="matchedDocuments" label="命中文档" min-width="200" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <span v-if="row.matchedDocuments" class="doc-list">{{ row.matchedDocuments }}</span>
          <span v-else style="color: #c0c4cc;">-</span>
        </template>
      </el-table-column>

      <el-table-column prop="workspaceName" label="命中文档所在知识库" width="120" align="center" show-overflow-tooltip />

      <el-table-column label="首次查询时间" width="160" align="center">
        <template slot-scope="{ row }">
          {{ formatDateTime(row.firstQueryTime) }}
        </template>
      </el-table-column>

      <el-table-column label="最近查询时间" width="160" align="center">
        <template slot-scope="{ row }">
          {{ formatDateTime(row.lastQueryTime) }}
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-wrapper">
      <el-pagination
        @size-change="onSizeChange"
        @current-change="onPageChange"
        :current-page="page + 1"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getHotSearchList,  exportHotSearch } from '@/api/dashboard'
import { getWorkspaceListByTenant } from '@/api/workspace'

export default {
  name: 'HotSearchDialog',
  data() {
    return {
      dialogVisible: false,
      loading: false,
      tableData: [],
      total: 0,
      page: 0,
      size: 20,
      dateRange: this.getDefaultDateRange(),
      workspaceSlug: '',
      isHit: null,
      keyword: '',
      minSearchCount: 2,
      workspaceList: [],
      workspaceLoading: false,
      
      // 统计摘要
      totalSearchCount: 0,
      totalHitCount: 0,
      totalNoHitCount: 0,
      overallHitRate: '0.00%',
      overallAvgConfidence: '0.00',

      pickerOptions: {
        shortcuts: [
          { text: '近7天', onClick: (picker) => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }},
          { text: '近30天', onClick: (picker) => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }},
          { text: '近90天', onClick: (picker) => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }}
        ]
      }
    }
  },
  computed: {
    tenantId() {
      return this.$store.getters['auth/currentTenant']?.tenantId || null
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.page = 0
      this.dateRange = this.getDefaultDateRange()
      this.workspaceSlug = ''
      this.isHit = null
      this.keyword = ''
      this.minSearchCount = 2
      this.loadWorkspaceList()
      this.loadData()
    },
    close() {
      this.dialogVisible = false
    },
    handleClose() {
      this.dialogVisible = false
    },

    getDefaultDateRange() {
      const end = new Date()
      const start = new Date()
      start.setDate(start.getDate() - 30)
      return [this.formatDate(start), this.formatDate(end)]
    },

    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },

    formatDateTime(dateStr) {
      if (!dateStr) return '-'
      const date = new Date(dateStr)
      if (isNaN(date.getTime())) return dateStr
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },

    /**
     * 加载工作区列表
     * 调用 /aics/kb_workspace/find_by_tenant API
     */
    async loadWorkspaceList() {
      if (!this.tenantId) {
        console.warn('tenantId 为空，无法加载工作区列表')
        return
      }

      this.workspaceLoading = true
      try {
        const res = await getWorkspaceListByTenant(this.tenantId)
        console.log('工作区列表响应:', res)

        if (res?.data?.code === 200) {
          const data = res.data.data
          if (Array.isArray(data) && data.length > 0) {
            this.workspaceList = data.map(item => ({
              slug: item.slug,
              name: item.name,
              id: item.id,
              category: item.category,
              documentCount: item.documentCount || 0
            }))
            console.log('工作区列表加载成功，共 ' + this.workspaceList.length + ' 个')
          } else {
            this.workspaceList = []
            console.warn('当前租户没有工作区')
          }
        } else {
          this.$message.warning(res?.data?.message || '加载工作区列表失败')
          this.workspaceList = []
        }
      } catch (error) {
        console.error('加载工作区列表失败:', error)
        this.$message.error('加载工作区列表失败: ' + (error.message || '未知错误'))
        this.workspaceList = []
      } finally {
        this.workspaceLoading = false
      }
    },

    getRankStyle(rank) {
      if (rank === 1) return { color: '#f56c6c', fontWeight: 'bold', fontSize: '16px' }
      if (rank === 2) return { color: '#e6a23c', fontWeight: 'bold', fontSize: '15px' }
      if (rank === 3) return { color: '#909399', fontWeight: 'bold', fontSize: '14px' }
      return { color: '#606266' }
    },

    getHitRateType(hitRate) {
      if (!hitRate) return 'danger'
      const rate = parseFloat(hitRate)
      if (rate >= 80) return 'success'
      if (rate >= 50) return 'warning'
      return 'danger'
    },

    getConfidenceColor(confidence) {
      if (confidence >= 0.8) return '#67c23a'
      if (confidence >= 0.5) return '#e6a23c'
      return '#f56c6c'
    },

    onDateChange() {
      this.page = 0
      this.loadData()
    },
    onSearch() {
      this.page = 0
      this.loadData()
    },
    onPageChange(page) {
      this.page = page - 1
      this.loadData()
    },
    onSizeChange(size) {
      this.size = size
      this.page = 0
      this.loadData()
    },

    async loadData() {
      if (!this.tenantId) {
        this.$message.warning('请先登录')
        return
      }

      this.loading = true
      try {
        const params = {
          tenantId: this.tenantId,
          startTime: this.dateRange[0] + ' 00:00:00',
          endTime: this.dateRange[1] + ' 23:59:59',
          page: this.page,
          size: this.size,
          workspaceSlug: this.workspaceSlug || '',
          isHit: this.isHit,
          keyword: this.keyword || '',
          minSearchCount: this.minSearchCount
        }

        const res = await getHotSearchList(params)
        console.log('热门搜索响应:', res)

        if (res?.data?.code === 200) {
          const data = res.data.data
          this.tableData = data?.content || []
          this.total = data?.number_of_elements || 0
          this.page = data?.pageable?.pageNumber || 0
          
          // 计算统计摘要
          this.calculateSummary(this.tableData)
        } else {
          this.$message.error(res?.data?.message || '加载失败')
          this.tableData = []
          this.total = 0
          this.resetSummary()
        }
      } catch (error) {
        console.error('加载热门搜索失败:', error)
        this.$message.error('加载失败: ' + (error.message || '未知错误'))
        this.tableData = []
        this.total = 0
        this.resetSummary()
      } finally {
        this.loading = false
      }
    },

    calculateSummary(data) {
      this.totalSearchCount = 0
      this.totalHitCount = 0
      this.totalNoHitCount = 0
      let totalConfidence = 0
      let confidenceCount = 0

      data.forEach(item => {
        this.totalSearchCount += item.searchCount || 0
        this.totalHitCount += item.hitCount || 0
        this.totalNoHitCount += item.noHitCount || 0
        if (item.avgConfidence > 0) {
          totalConfidence += item.avgConfidence
          confidenceCount++
        }
      })

      // 计算整体命中率
      if (this.totalSearchCount > 0) {
        const rate = (this.totalHitCount / this.totalSearchCount) * 100
        this.overallHitRate = rate.toFixed(2) + '%'
      } else {
        this.overallHitRate = '0.00%'
      }

      // 计算平均置信度
      if (confidenceCount > 0) {
        this.overallAvgConfidence = (totalConfidence / confidenceCount).toFixed(2)
      } else {
        this.overallAvgConfidence = '0.00'
      }
    },

    resetSummary() {
      this.totalSearchCount = 0
      this.totalHitCount = 0
      this.totalNoHitCount = 0
      this.overallHitRate = '0.00%'
      this.overallAvgConfidence = '0.00'
    },

   /**
     * 导出热门搜索数据
     */
    async handleExport() {
      if (!this.tenantId) {
        this.$message.warning('请先登录')
        return
      }

      // 检查是否有数据可导出
      if (this.total === 0) {
        this.$message.warning('没有数据可导出')
        return
      }

      this.exportLoading = true
      try {
        const params = {
          tenantId: this.tenantId,
          startTime: this.dateRange[0] + ' 00:00:00',
          endTime: this.dateRange[1] + ' 23:59:59',
          workspaceSlug: this.workspaceSlug || '',
          isHit: this.isHit,
          keyword: this.keyword || '',
          minSearchCount: this.minSearchCount
        }

        const response = await exportHotSearch(params)
        console.log('导出响应:', response)

        // 处理文件下载
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })

        // 检查是否是错误响应（blob 可能包含错误信息）
        if (blob.size === 0) {
          this.$message.error('导出的文件为空')
          return
        }

        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)

        // 从响应头获取文件名
        const disposition = response.headers['content-disposition']
        let fileName = `热门搜索与命中分析_${new Date().toISOString().slice(0, 10)}.xlsx`
        if (disposition) {
          const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
          if (match && match[1]) {
            fileName = decodeURIComponent(match[1].replace(/['"]/g, ''))
          }
        }

        link.download = fileName
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        // 延迟释放 URL
        setTimeout(() => {
          URL.revokeObjectURL(link.href)
        }, 100)

        this.$message.success('导出成功')

      } catch (error) {
        console.error('导出失败:', error)
        // 尝试解析错误信息
        if (error.response && error.response.data) {
          const text = await error.response.data.text()
          this.$message.error('导出失败: ' + text)
        } else {
          this.$message.error('导出失败，请重试')
        }
      } finally {
        this.exportLoading = false
      }
    },
    /**
     * 获取导出按钮文本（显示加载状态）
     */
    getExportButtonText() {
      return this.exportLoading ? '导出中...' : '导出'
    }

  }
}
</script>

<style scoped>
.filter-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}

.summary-bar {
  background: #f5f7fa;
  border-radius: 6px;
  padding: 12px 20px;
  margin-top: 12px;
}

.summary-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.summary-label {
  color: #909399;
  font-size: 13px;
}

.summary-value {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

::v-deep .el-dialog__body {
  padding: 20px 20px 10px 20px;
}

.query-text {
  font-weight: 500;
  color: #303133;
}

.doc-list {
  font-size: 12px;
  color: #606266;
  line-height: 1.4;
}

/* ===== 分页器样式 ===== */
::v-deep .el-pagination .btn-prev .el-icon,
::v-deep .el-pagination .btn-next .el-icon,
::v-deep .el-pagination .el-icon-arrow-left,
::v-deep .el-pagination .el-icon-arrow-right {
  display: none !important;
}

::v-deep .el-pagination .btn-prev {
  position: relative;
}
::v-deep .el-pagination .btn-prev::after {
  content: '<' !important;
  font-size: 14px !important;
  font-family: sans-serif !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #606266;
}

::v-deep .el-pagination .btn-next {
  position: relative;
}
::v-deep .el-pagination .btn-next::after {
  content: '>' !important;
  font-size: 14px !important;
  font-family: sans-serif !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #606266;
}

::v-deep .el-input__clear {
  display: none !important;
}

::v-deep .el-input__prefix {
  display: flex !important;
  align-items: center !important;
  left: 5px !important;
}
</style>